<template>
  <div id="targetControl">
    <b-collapse :visible="targetListVisibility" id="targetList">
      <div class="targetActionButtonsDiv">
        <b-button class="btn btn-primary btn-sm" @click="addRouteTarget" v-b-tooltip.hover
          :title="$t('document_targets.add_route_target_btn')">
          <b-icon icon="arrow-left" font-scale="1.5"></b-icon>
        </b-button>
        <b-button class="btn btn-primary btn-sm" @click="addVehicleTarget" v-b-tooltip.hover
          :title="$t('document_targets.add_vehicle_target_btn')">
          <b-icon icon="truck" font-scale="1.5"></b-icon>
        </b-button>
        <b-button class="btn btn-danger btn-sm" @click="removeTargets" v-b-tooltip.hover
          :title="$t('document_targets.del_target_btn')">
          <b-icon icon="X" font-scale="1.5"></b-icon>
        </b-button>
      </div>
      <DocumentTargetList ref="targetList" :targetdata="targetList"></DocumentTargetList>
    </b-collapse>

    <!-- Routes -->
    <b-collapse :visible="routeListVisibility">
      <b-button class="btn btn-primary btn-sm" v-b-tooltip.hover :title="$t('document_targets.ok_btn')"
        @click="submitAddRouteTargets">
        <b-icon icon="arrow-left" font-scale="1.5"></b-icon> {{ $t('document_targets.ok_btn') }}
      </b-button>
      <b-button class="btn btn-danger btn-sm" v-b-tooltip.hover :title="$t('document_targets.cancel_btn')"
        @click="hideTargetLists">
        <b-icon icon="X" font-scale="1.5"></b-icon> {{ $t('document_targets.cancel_btn') }}
      </b-button>
      <RouteList ref="routeList"></RouteList>
    </b-collapse>

    <!-- Vehicles -->
    <b-collapse :visible="vehicleListVisibility">
      <b-button class="btn btn-primary btn-sm" v-b-tooltip.hover :title="$t('document_targets.ok_btn')"
        @click="submitAddVehicleTargets">
        <b-icon icon="truck" font-scale="1.5"></b-icon> {{ $t('document_targets.ok_btn') }}
      </b-button>
      <b-button class="btn btn-primary btn-sm" v-b-tooltip.hover :title="$t('document_targets.add_all_vehicles_btn')"
        @click="addAllVehicles">
        <b-icon icon="plus-square-fill" font-scale="1.5"></b-icon> {{ $t('document_targets.add_all_vehicles_btn') }}
      </b-button>
      <b-button class="btn btn-danger btn-sm" v-b-tooltip.hover :title="$t('document_targets.cancel_btn')"
        @click="hideTargetLists">
        <b-icon icon="X" font-scale="1.5"></b-icon> {{ $t('document_targets.cancel_btn') }}
      </b-button>
      <VehicleList ref="vehicleList"></VehicleList>
    </b-collapse>
  </div>
</template>

<script>
import DocumentTargetList from '@/components/Content/Documents/DocumentTargetList.vue';
import RouteList from '@/components/Timetable/RouteList.vue';
import VehicleList from '@/components/Realtime/VehicleList.vue';

export default {
  name: 'DocumentTargets',
  props: {
    targetdata: Array,
    creatingNew: Boolean
  },
  data() {
    return {
      routeListVisibility: false,
      vehicleListVisibility: false,
      targetListVisibility: true,
      targetList: [],
      creatingNewTargets: false
    };
  },
  components: {
    DocumentTargetList,
    RouteList,
    VehicleList
  },
  created() {
    this.targetList = this.targetdata || [];
  },
  watch: {
    targetdata() {
      this.targetList = this.targetdata || [];
    },
    creatingNew() {
      if (this.creatingNew) {
        this.createNewDocument();
      }
    }
  },
  methods: {
    clearTargetLists() {
      this.$refs.targetList.emptyList();
    },
    addRouteTarget() {
      this.targetListVisibility = false;
      this.routeListVisibility = true;
      this.vehicleListVisibility = false;
    },
    addVehicleTarget() {
      this.targetListVisibility = false;
      this.routeListVisibility = false;
      this.vehicleListVisibility = true;
    },
    hideTargetLists() {
      this.routeListVisibility = false;
      this.vehicleListVisibility = false;
      this.targetListVisibility = true;
    },
    createNewDocument() {
      this.targetListVisibility = true;
      this.routeListVisibility = false;
      this.vehicleListVisibility = false;
      this.$refs.targetList.emptyList();
    },
    submitAddRouteTargets() {
      const toBeAdded = this.$refs.routeList.getSelectedList();
      const targetList = toBeAdded.map(item => ({
        id: item.tunnus,
        label: item.nimi,
        type: 'route'
      }));
      this.$refs.targetList.addTargets(targetList);
      this.$refs.routeList.deselectAll();
      this.hideTargetLists();
    },
    submitAddVehicleTargets() {
      const toBeAdded = this.$refs.vehicleList.getSelectedList();
      const targetList = toBeAdded.map(item => ({
        id: item.vehicleId.toString(),
        label: item.vehicleLabel,
        type: 'vehicle'
      }));
      this.$refs.targetList.addTargets(targetList);
      this.$refs.vehicleList.deselectAll();
      this.hideTargetLists();
    },
    addAllVehicles() {
      const allVehicles = this.$refs.vehicleList.listData;
      const targetList = allVehicles.map(item => ({
        id: item.vehicleId.toString(),
        label: item.vehicleLabel,
        type: 'vehicle'
      }));
      this.$refs.targetList.addTargets(targetList);
      this.$refs.vehicleList.deselectAll();
      this.hideTargetLists();
    },
    removeTargets() {
      this.$refs.targetList.removeSelectedTargets();
    },
    getTargets() {
      return this.$refs.targetList.getTargetListData();
    }
  }
}
</script>

<style scoped lang="scss">
.targetActionButtonsDiv {
  margin-bottom: 1em;
}
</style>
